import React from 'react';
import request from 'superagent';
import { I18n } from 'react-redux-i18n';
import { trackYandexGoal } from '../../../../../actions/utils';
import UiButton from '@ui/Button';
import { BEMHelper } from '@utils/customBEMHelper';

import './styles.scss';
import { getTimeZone } from '@utils/date';

const classes = new BEMHelper({
  name: 'payment-option-gazprom',
});

class Button extends React.PureComponent {
  state = {
    loading: false,
  };

  processPayment = () => {
    const { plan, receiverId, phone, isValid, email, onClickPay } = this.props;
    const { loading } = this.state;

    onClickPay();

    if (loading || !isValid) return;

    trackYandexGoal(`buy-${plan}`);

    this.setState({ loading: true });

    request
      .post('/payment/init')
      .send({
        tel: phone,
        plan,
        receiverId,
        email,
        method: 'gazprom',
        timezone: getTimeZone(),
      })
      .end((err, res) => {
        this.setState({ loading: false });
        if (!err && res.body.url) window.location = res.body.url;
      });
  };

  render() {
    return (
      <UiButton
        onClick={this.processPayment}
        color="green"
        size="big"
        className={classes('btn')}
      >
        {I18n.t('other.payByCard')}
      </UiButton>
    );
  }
}

export default Button;
